import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'day8-ui';
import { IoIosGlobe } from "@react-icons/all-files/io/IoIosGlobe";
import {
  getSelectedFilters, isFilterSelected, onFilterSelect
} from '../../../../helpers/filter';
import { FILTERS } from '../../../../constants';
import { useDispatch, useSelector } from 'react-redux';

const CountryFilter = props => {
  const dispatch = useDispatch();
  const destinations = props.destinations || useSelector(state => state.destinations.items);
  const filteredBookingOptions = useSelector(state => state.bookingOptions.filtered);
  const filteredYachts = useSelector(state => state.yachts.filtered);
  const countryOptions = [...new Set(destinations.map(destination => destination.country))];
  const selectedFilterText = getSelectedFilters(props.location)[FILTERS.COUNTRY].map(itemValue => countryOptions.find(i => i === itemValue)).join(', ');
  // function to check if option should be disabled
  // TODO: need to decide what we want - this approach is not allowing comparing multiple ones
  const isCountryOptionDisabled =
    countryOption => filteredBookingOptions.every(bookingOption => bookingOption.week.destination.country !== countryOption) &&
    filteredYachts.every(yacht => yacht.week.destinationCountry !== countryOption);
  return props.mobile ? (
    <div className={props.className}>
      <h3 className='dui-font-body !dui-font-normal dui-tracking-normal'>Country</h3>
      <div className='dui-flex dui-flex-wrap dui-gap-4 dui-mt-4'>
        {countryOptions.map(item => (
          <Button key={JSON.stringify(item)} buttonType={isFilterSelected(props.location, FILTERS.COUNTRY, item) ? 'FILTER_ACTIVE' : 'FILTER'} onClick={() => onFilterSelect(props.location, dispatch, props.filterAction, FILTERS.COUNTRY, item)}>{item}</Button>
        ))}
      </div>
    </div>
  ) : <Button buttonType="LINK" onClick={props.filterModalToggle} leftIcon={<IoIosGlobe />}>{selectedFilterText || 'Country'}</Button>;
};
CountryFilter.propTypes = {
  mobile: PropTypes.bool,
  filterModalToggle: PropTypes.bool,
  className: PropTypes.string,
  filterAction: PropTypes.func.isRequired
};
export default CountryFilter;
